import googleLogo from '~/assets/images/auth/google_logo.svg';

/**
 * Google "G" logo icon component
 * Following official Google branding guidelines
 * @see https://developers.google.com/identity/branding-guidelines
 */
export function GoogleIcon({ className }: { className?: string }) {
  return (
    <img src={googleLogo} alt="" className={className} width="24" height="24" aria-hidden="true" />
  );
}
